import { useState } from "react";
import { DataPoint, Line, Plot } from "../../types";


function Tooltip({ position, info }: { position: { x: number, y: number }, info: { plot: Plot, values: {date: Date | string, value: number} } }) {

    const processedDate = (info.values.date as Date).toISOString().split('T')[0].split('-').slice(0,2).join('-');
    const tooltipWidth = info.plot.label.length * 7 > 150 ? info.plot.label.length * 7 : 100;
    const tooltipHeight = 70;
    const fontSize = 12;

    return (
        <g transform={`translate(${position.x -tooltipWidth},${position.y -tooltipHeight/2})`}>
            <rect
                opacity={0.8}
                fill="white"
                stroke="grey"
                rx={5}
                width={tooltipWidth}
                height={tooltipHeight}
            />
            <text fontSize={fontSize} x={5} y={20}>{info.plot.label}</text>
            <text fontSize={fontSize} x={5} y={40}>{processedDate}</text>
            <text fontSize={fontSize} x={5} y={60}>{info.values.value.toFixed(2)} €</text>

        </g>

    )


}



export function DottedLinesRenderer({ xScale, yScale, data }: { xScale: any, yScale: any, data?: Line[] }) {

    const [hoveredCircle, setHoveredCircle] = useState<{ lineIdx: number, pointIdx: number } | null>(null);

    const handleCircleHover = (lineIdx: number, pointIdx: number) => {
        setHoveredCircle({ lineIdx, pointIdx: pointIdx });
    }

    const isCircleHovered = (lineIdx: number, pointIdx: number) => {
        return hoveredCircle?.lineIdx === lineIdx && hoveredCircle?.pointIdx === pointIdx;
    }

    if (!data || data.length === 0) return null;

    return (
        <g>
            {data.map((line: Line, lineIdx: number) => {
                const points = line?.dataPoints;
                const metadata = line?.metadata;
                return (
                    <g key={lineIdx}>
                        {points?.map((point: DataPoint, pointIndex: number) => {
                            if (pointIndex < points.length - 1) {
                                const point1 = point;
                                const point2 = points[pointIndex + 1];
                                return (<g key={pointIndex}>
                                    <line x1={xScale(point1.x)} x2={xScale(point2.x)} y1={yScale(point.y)} y2={yScale(point2.y)} stroke={metadata.color} strokeWidth={2} />
                                    {isCircleHovered(lineIdx, pointIndex)? <Tooltip info={{plot: metadata, values: {date: point.x, value: point.y}}} position={{x: xScale(point.x), y:yScale(point.y)}}/> : null}
                                    <circle onMouseLeave={() => setHoveredCircle(null)} onMouseEnter={() => handleCircleHover(lineIdx, pointIndex)} cx={xScale(point.x)} cy={yScale(point.y)} r={isCircleHovered(lineIdx, pointIndex) ? 7 : 3} stroke={metadata.color} fill={isCircleHovered(lineIdx, pointIndex) ? `white` : metadata.color} />
                                </g>)
                            } else {
                                return <g  key={pointIndex}>
                                    {isCircleHovered(lineIdx, pointIndex)? <Tooltip info={{plot: metadata, values: {date: point.x, value: point.y}}} position={{x: xScale(point.x), y:yScale(point.y)}}/> : null}
                                    <circle onMouseLeave={() => setHoveredCircle(null)} onMouseEnter={() => handleCircleHover(lineIdx, pointIndex)} cx={xScale(point.x)} cy={yScale(point.y)} r={isCircleHovered(lineIdx, pointIndex) ? 7 : 3} stroke={metadata.color} fill={isCircleHovered(lineIdx, pointIndex) ? `white` : metadata.color} />

                                </g> 
                            }
                        })}

                    </g>
                )
            })}

        </g>
    )


}